interface AppTitleProps {
  title: string;
  subtitle: string;
  hideOnMobile?: boolean;
}

export default function AppTitle({
  title,
  subtitle,
  hideOnMobile = false,
}: AppTitleProps) {
  return (
    <div
      className={`min-w-0 text-left ${hideOnMobile ? "hidden sm:block" : ""}`}
    >
      <h1 className="font-display text-[13px] font-semibold leading-tight text-content truncate max-sm:max-w-[9.5rem] max-sm:text-xs">
        {title}
      </h1>
      <p className="text-[11px] leading-tight text-content-faint truncate">
        {subtitle}
      </p>
    </div>
  );
}
